<template>
  <div class="container">
    <div class="info">
      <!-- 标题 -->
      <div class="title">{{ $t('share').Invitationrecord }}</div>
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}{{ active ==
              item.value ? total : ''
            }}</span></div>
      </div>
      <!-- 列表 -->
      <div class="listInfo">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`" @click="showOrderInfo = true">
          <div class="name">{{ dItem.memberName | truncateString }}</div>
          <div class="time">{{ dItem.createTime | getLocalTime }}</div>
        </div>
        <!-- 分页 -->
        <div class="pagefoot">
          <el-pagination :current-page="parms.pageNum" :page-size="parms.pageSize" layout="prev, pager, next" hide-on-single-page :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'

export default {
  components: {
  },
  data() {
    return {
      showOrderInfo: false,
      showSetInfo: false,
      StopSurplusPrice: '',
      StopLossPrice: '',
      active: "1",
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 10,
      },
      oList: [],
      total: 0,
    }
  },
  computed: {
    tabs() {
      return [{
        name: this.$t('share').Firstlevelmembers,
        value: "1",
      }, {
        name: this.$t('share').Secondlevelmembers,
        value: "2",
      }, {
        name: this.$t('share').Thirdlevelmembers,
        value: "3",
      },
      ]
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getInviteLog()
  },
  methods: {
    changeTab(val) {
      this.active = val
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getInviteLog()
    },
    // 切换分页
    handleCurrentChange(val) {
      this.parms.pageNum = val
      this.getInviteLog()
    },
    // 获取邀请记录
    async getInviteLog() {
      this.parms.type = this.active
      const res = await userApi.getInviteLog(this.parms)
      this.oList = res.rows
      this.total = res.total
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 50px 15px 15px 15px;
  background: var(--background_color);
  min-height: 100vh;
  padding-top: 110px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 780px;

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .top {
      margin-top: 30px;
      width: 100%;
      background: var(--background_color);
      padding-bottom: 12px;
      border-bottom: 1px solid rgba(151, 177, 199, 0.3);

      .tabs {
        font-size: 18px;
        color: var(--ntext_color);

        span {
          margin-right: 40px;
        }

        .active {
          color: var(--primary_color);
          padding-bottom: 10px;
          border-bottom: 2px solid var(--primary_color);
        }
      }
    }

    .listInfo {
      margin-top: 30px;
      padding-bottom: 80px;

      .item {
        padding: 20px;
        background: var(--background_color);
        color: var(--text_color);
        font-size: 15px;
        border-bottom: 1px solid rgba(151, 177, 199, 0.3);

        .name {
          display: flex;
          justify-content: space-between;
          font-size: 18px;
          color: var(--text_color);
        }

        .time {
          margin-top: 20px;
          font-size: 14px;
          color: var(--ntext_color);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }

      .item:hover {
        background: var(--info_color);
      }

      .pagefoot {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}

// 分页
::v-deep .el-pagination button {
  color: var(--text_color);
  background-color: var(--background_color);
}

::v-deep .el-pager li {
  background: var(--background_color);
  color: var(--text_color);
}

::v-deep .el-pager li.active {
  color: #fff;
  background: var(--primary_color);
  border-radius: 15px;
}
</style>
